import React from 'react';
interface ComputerIconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
}
const ComputerIcon: React.FC<ComputerIconProps> = ({
  fillColor = '#AAAAAA',
  ...rest
}) => {
  return (
    <svg
      {...rest}
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Combined Shape"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16683 13.347H3.3335C2.87326 13.347 2.50016 12.9455 2.50016 12.4503V3.48311C2.50016 2.98787 2.87326 2.5864 3.3335 2.5864H16.6668C17.1271 2.5864 17.5002 2.98787 17.5002 3.48311V12.4503C17.5002 12.9455 17.1271 13.347 16.6668 13.347H15.8335C15.3733 13.347 15.0002 13.7485 15.0002 14.2437C15.0002 14.7389 15.3733 15.1404 15.8335 15.1404H16.6668C18.0475 15.1404 19.1668 13.936 19.1668 12.4503V3.48311C19.1668 1.99739 18.0475 0.792969 16.6668 0.792969H3.3335C1.95278 0.792969 0.833496 1.99739 0.833496 3.48311V12.4503C0.833496 13.936 1.95278 15.1404 3.3335 15.1404H4.16683C4.62707 15.1404 5.00016 14.7389 5.00016 14.2437C5.00016 13.7485 4.62707 13.347 4.16683 13.347ZM10.6403 11.8762L14.807 17.2565C15.2593 17.8405 14.8734 18.7273 14.1668 18.7273H5.8335C5.12696 18.7273 4.741 17.8405 5.19331 17.2565L9.35998 11.8762C9.69314 11.446 10.3072 11.446 10.6403 11.8762ZM12.3876 16.9338H7.6127L10.0002 13.851L12.3876 16.9338Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default ComputerIcon;
